import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { resolvePostLoginDestination } from "../../../utils/onboarding/onboardingAccess";
import ICharity from "../../../types/services/ICharity";
import LoadingScreen from "../../../toolkit/loadingScreen";

interface Props {
  children: React.ReactNode;
  isLoggedIn: boolean;
  isDonationReader: boolean;
  isSuperadmin: boolean;
  isOnboardingOperator: boolean;
  currentCharity: ICharity;
  isRehydrated: boolean;
  firebaseData: any;
}

const GuestRoute: React.FC<Props> = ({
  children,
  isLoggedIn,
  isDonationReader,
  isSuperadmin,
  isOnboardingOperator,
  currentCharity,
  isRehydrated,
  firebaseData,
}) => {
  if (!isRehydrated) {
    return <LoadingScreen />;
  }

  if (isLoggedIn) {
    if (isDonationReader) {
      return <Navigate to="/allDonations" replace />;
    }

    const currentCharityId = currentCharity?.id;
    if (currentCharityId) {
      const destination = resolvePostLoginDestination(
        { isSuperadmin, isOnboardingOperator },
        currentCharityId,
        firebaseData
      );
      if (destination !== "/contacts") {
        return <Navigate to={destination} replace />;
      }
    }

    return <Navigate to="/contacts" replace />;
  }

  return <>{children}</>;
};

const mapStateToProps = state => {
  const { firebase, user, _persist } = state;
  return {
    firebaseData: firebase.data || {},
    isLoggedIn: user.isLoggedIn,
    isDonationReader: user.isDonationReader,
    isSuperadmin: user.isSuperadmin,
    isOnboardingOperator: user.isOnboardingOperator,
    currentCharity: user.currentCharity,
    isRehydrated: _persist?.rehydrated ?? false,
  };
};

export default connect(mapStateToProps)(GuestRoute);
